module.exports = __webpack_public_path__ + "img/video-bf-Completed.bae06579.png";